// extracted by mini-css-extract-plugin
export default {"wrapper":"NewProducts_wrapper__t0C8-","item":"NewProducts_item__iDsOh"};